import React, { useEffect, useRef } from 'react';
import Quill from 'quill';
import 'quill/dist/quill.snow.css';
import '../../assets/css/Quill.css'
import { get } from 'jquery';

const removePTagsInsideLI = (html) => {
  const parser = new DOMParser();
  const doc = parser.parseFromString(html, 'text/html');
  const liElements = doc.querySelectorAll('li');

  liElements.forEach((li) => {
    Array.from(li.childNodes).forEach((child) => {
      if (child.nodeName === 'P' && child.nodeType === Node.ELEMENT_NODE) {
        const fragment = document.createDocumentFragment();
        while (child.firstChild) {
          fragment.appendChild(child.firstChild);
        }
        li.replaceChild(fragment, child);
      }
    });
  });

  return doc.body.innerHTML;
}

const QuillEditor = ({ content, value, height, toolbar, onChange, onReady }) => {
  const editorRef = useRef(null);
  const quillRef = useRef(null);

  // Register custom font sizes
  const Size = Quill.import('formats/size');
  Size.whitelist = ['small', 'normal', 'large', 'huge'];
  Quill.register(Size, true);

  // Register alignment format
  const Align = Quill.import('formats/align');
  Align.whitelist = ['left', 'center', 'right', 'justify'];
  Quill.register(Align, true);

  const getToolbarOptions = () => {
    if (toolbar && toolbar === 'simple') {
      return [
        ['bold', 'italic', 'underline', 'strike'],
        [{ color: [] }, { background: [] }],
        [{ align: [] }, { indent: '-1' }, { indent: '+1' }],
        [{ list: 'ordered' }, { list: 'bullet' }],
        ['clean'],
      ];
    }

    return [
      [{ header: [1, 2, 3, 4, false] }],
      ['bold', 'italic', 'underline', 'strike', { script: 'sub' }, { script: 'super' }],
      [{ font: [] }, { size: ['small', false, 'large', 'huge'] }],
      [{ color: [] }, { background: [] }],
      [{ 'align': [] }, { indent: '-1' }, { indent: '+1' }],
      [{ list: 'ordered' }, { list: 'bullet' }],
      ['image', 'link', 'code-block'],
      ['clean'],
    ]
  }

  useEffect(() => {
    if (!editorRef.current) {
      return;
    }

    quillRef.current = new Quill(editorRef.current, {
      theme: 'snow',
      modules: {
        table: true,
        toolbar: getToolbarOptions(),
      },
      formats: [
        'list', 'bullet', 'ordered', 'bold', 'italic', 'underline', 'strike', 'script',
        'link', 'image', 'link', 'code-block', 'header', 'align',
        'indent', 'color', 'background', 'font', 'size', 'direction', 'script', 'table',
      ],
    });
    
    quillRef.current.clipboard.dangerouslyPasteHTML(content || '');

    quillRef.current.on('text-change', () => {
      const html = quillRef.current.root.innerHTML;
      onChange && onChange(html);
    });

    onReady && onReady(quillRef.current);
  }, []);

  useEffect(() => {
    if (quillRef.current && value !== undefined) {
      const currentHTML = quillRef.current.root.innerHTML;
      if (value !== currentHTML) {
        const sel = quillRef.current.getSelection(); // preserve cursor
        quillRef.current.clipboard.dangerouslyPasteHTML(value);
        if (sel) quillRef.current.setSelection(sel);
      }
    }
  }, [value]);

  return <div ref={editorRef} className="quill-editor" style={{ 
    resize: 'vertical',
    overflow: 'auto',
    minHeight: height ? height : '300px',
  }} />;
}

export default QuillEditor;